export const SEARCH = 'search';
export const ALBUM = 'album';
export const PLAYLIST = 'playlist';
export const BRIEF = 'brief';
export const VERSIONS = 'versions';
export const TRACK = 'track';
